import { render, staticRenderFns } from "./PlanAllocate.vue?vue&type=template&id=59462558"
import script from "./PlanAllocate.vue?vue&type=script&lang=js"
export * from "./PlanAllocate.vue?vue&type=script&lang=js"
import style0 from "./PlanAllocate.vue?vue&type=style&index=0&id=59462558&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports